import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { InfoParams } from './info';

@Component({
  templateUrl: 'informdialog.component.html',
  styleUrls: ['dialog.component.scss'],
  standalone: false,
})
export class InfoDialogComponent {
  data = inject<InfoParams>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<InfoDialogComponent>>(MatDialogRef);

  trustedHtml: SafeHtml;

  constructor() {
    const data = this.data;
    const sanitizer = inject(DomSanitizer);

    this.trustedHtml = sanitizer.bypassSecurityTrustHtml(data.message);
  }

  yes() {
    this.dialogRef.close(true);
  }
}
